import './Eventos.css';
import Header from '../../components/Header/Header';
import Workshop from '../../assets/eventos/inovacao.jpg';
import Motivacional from '../../assets/eventos/motivacao.jpg';
import GoogleImg from '../../assets/eventos/google-workshop.jpg';
import Title from '../../components/Title/Title';
import { useTranslation } from "react-i18next";
import { PageSeo } from '../../seo/Seo';

export default function Eventos() {
  const { t } = useTranslation();

  const eventos = [
    {
      id: 1,
      titulo: t('eventos.items.workshop.title', 'Workshop de Inovação'),
      descricao: t('eventos.items.workshop.desc', 'Participe do nosso workshop sobre inovação e tecnologia.'),
      data: "15/09/2025",
      imagem: Workshop,
    },
    {
      id: 2,
      titulo: t('eventos.items.talk.title', 'Palestra Motivacional'),
      descricao: t('eventos.items.talk.desc', 'Venha se inspirar com especialistas do setor.'),
      data: "22/09/2025",
      imagem: Motivacional,
    },
    {
      id: 3,
      titulo: t('eventos.items.google.title', 'Eventos Google'),
      descricao: t('eventos.items.google.desc', 'Networking e oportunidades para sua empresa.'),
      data: "05/10/2025",
      imagem: GoogleImg,
    },
    {
      id: 4,
      titulo: t('eventos.items.google.title', 'Eventos Google'),
      descricao: t('eventos.items.google.desc', 'Networking e oportunidades para sua empresa.'),
      data: "05/10/2025",
      imagem: GoogleImg,
    },
    {
      id: 5,
      titulo: t('eventos.items.google.title', 'Eventos Google'),
      descricao: t('eventos.items.google.desc', 'Networking e oportunidades para sua empresa.'),
      data: "05/10/2025",
      imagem: GoogleImg,
    },
    {
      id: 6,
      titulo: t('eventos.items.google.title', 'Eventos Google'),
      descricao: t('eventos.items.google.desc', 'Networking e oportunidades para sua empresa.'),
      data: "05/10/2025",
      imagem: GoogleImg,
    }
  ];

  return (
    <div className='eventos-page'>
      <PageSeo page="eventos" path="/eventos" />
      <Header />
      <Title>{t('eventos.title', 'Eventos')}</Title>

      <div className="container">
        <div className="eventos-header">
          <h2 className="eventos-title">
            {t('eventos.hero_title', 'Confira os próximos eventos!')}
          </h2>
          <h4>{t('eventos.hero_subtitle', 'Eventos da Calriz preparados para você!')}</h4>
        </div>
        <div className="eventosGrid">
          {eventos.map((evento) => (
            <div key={evento.id} className="eventoCard">
              <img src={evento.imagem} alt={evento.titulo} className="eventoImagem" />
              <div className="eventoConteudo">
                <h2 className="eventoTitulo">{evento.titulo}</h2>
                <p className="eventoDescricao">{evento.descricao}</p>
                <span className="eventoData">{evento.data}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}